import { gql } from '@apollo/client';

export const EXPORT_FUNDER_PROGRAMMES = gql`
  query ExportFunderProgrammes($input: ExportArgs) {
    exportFunderProgrammes(input: $input) {
      id
      fromDate
      toDate
      name
      summary
      theoryOfChange
    }
  }
`;
